class AddOneMoreButton {
  constructor() {
    this.buttons = document.querySelectorAll('button.add-one-more:not([type="submit"])');
    this.initialize();
  }

  initialize() {
    this.removeEventListeners();
    this.addEventListeners();
  }

  removeEventListeners() {
    this.buttons.forEach(button => {
      button.removeEventListener('click', this.handleAddOneMore);
    });
  }

  addEventListeners() {
    this.buttons.forEach((button, index) => {
      button.addEventListener('click', this.handleAddOneMore.bind(this));
    });
  }

  async handleAddOneMore(event) {
    event.preventDefault(); // Prevent any default button behavior
    event.stopPropagation(); // Ensure the event doesn't bubble up to the form
    
    const button = event.currentTarget;
    const variantId = button.getAttribute('data-variant-id');
    const itemKey = button.getAttribute('data-item-key');
    const bundleComponentsData = button.getAttribute('data-bundle-components');
    

    if (!variantId || !itemKey) {
      console.error('Missing variantId or itemKey');
      alert('Error: Missing product information. Please refresh the page and try again.');
      return;
    }

    const uniqueKey = `${itemKey}-${Date.now()}`;
    
    const properties = {
      _uniqueKey: uniqueKey
    };
    
    // Add bundle components if present
    if (bundleComponentsData) {
      properties.bundle_components = bundleComponentsData;
    }
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            quantity: 1,
            id: variantId,
            properties: properties
          }]
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.items && data.items.length > 0) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        location.reload();
      } else {
        throw new Error('Item not added to cart');
      }
    } catch (error) {
      console.error('Error adding item:', error);
      alert('Failed to add item to cart. Please try again.');
    }
  }
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', () => {
  new AddOneMoreButton();
});

// Re-initialize after cart updates
document.addEventListener('cart:refresh', () => {
  new AddOneMoreButton();
});

document.addEventListener('cartUpdateCompleted', () => {
  new AddOneMoreButton();
});

// Make the class available globally
window.AddOneMoreButton = AddOneMoreButton;
